import {I18nIndividual as GedcomIndividual} from "../model/gedcom-individual"
import {I18nFamily as GedcomFamily} from "../model/gedcom-family"
import {Input, TableCell} from "semantic-ui-react"
import {CustomDatePicker} from "../datepicker/custom-datepicker"
import {DateOrYear} from "../datepicker/date-or-year"


/**
 * Custom date column for react-table.
 */
export const createDateCell = <T extends GedcomIndividual | GedcomFamily>(
    field: keyof T,
    rowIndex: number,
    onChange: (rowIndex: number, field: keyof T, value: any) => void,
    value?: DateOrYear,
    className?: string
) => {
    return (
        <TableCell className={className}>
            {process.env.REACT_APP_CUSTOM_DATE_PICKER === "true"
                ? <CustomDatePicker
                    id={`datepicker_${rowIndex}_${field.toString()}`}
                    value={value}
                    onChange={(value) => onChange(rowIndex, field, value)}
                    className={className}/>
                : <Input
                    type="date"
                    value={value}
                    className={className}
                    onChange={e => onChange(rowIndex, field, e.target.value ? new Date(e.target.value) : null)}
            />}
        </TableCell>
    )
}